"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_KIT_PERMISSIONS = exports.KitPermissions = void 0;
/** Permission string catalog for Kit Master (Stage 14, Phase 1, Step 1b — Pharmacy Master Data Foundation). */
exports.KitPermissions = {
    KIT_MASTER_READ: 'kit-master:read',
    KIT_MASTER_CREATE: 'kit-master:create',
    KIT_MASTER_UPDATE: 'kit-master:update',
    KIT_MASTER_DELETE: 'kit-master:delete',
    KIT_MASTER_MANAGE: 'kit-master:manage',
    KIT_MASTER_APPROVE: 'kit-master:approve',
};
exports.ALL_KIT_PERMISSIONS = Object.values(exports.KitPermissions);
//# sourceMappingURL=kit.permissions.js.map